var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4149 7.77429C15.3892 7.78375 15.3635 7.79388 15.3372 7.80267C15.3635 7.79388 15.3892 7.78375 15.4149 7.77429Z",
    fill: "url(#paint0_linear_719_3077)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3372 7.80267C15.2845 7.82024 15.2311 7.83646 15.1777 7.85132C15.2311 7.83646 15.2845 7.82092 15.3372 7.80267Z",
    fill: "url(#paint1_linear_719_3077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2344 7.32971C15.981 7.52025 15.704 7.66755 15.4148 7.77431C15.7047 7.66823 15.981 7.52025 16.2344 7.32971Z",
    fill: "url(#paint2_linear_719_3077)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2487 7.32027C16.2487 7.31959 16.2487 7.31959 16.2487 7.32027C16.244 7.32297 16.2392 7.32635 16.2345 7.32973C16.2392 7.32635 16.244 7.32365 16.2487 7.32027Z",
    fill: "url(#paint3_linear_719_3077)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1777 7.85132C15.1398 7.86213 15.1027 7.87227 15.0648 7.88105C15.1027 7.87227 15.1398 7.86213 15.1777 7.85132Z",
    fill: "url(#paint4_linear_719_3077)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0317383 9.97431C0.0317383 9.9858 0.0317383 9.99729 0.0317383 10.0088C0.0317383 12.8946 1.26012 15.579 3.37768 17.4594C2.84052 16.9101 2.51822 16.1736 2.48241 15.3939C2.48039 15.3446 2.47904 15.2946 2.47904 15.2453C2.47904 15.1649 2.48512 15.0845 2.4912 15.0047C2.02904 13.9669 1.78106 12.8284 1.78106 11.6486C1.78106 11.6392 1.78106 11.6297 1.78106 11.6203C1.79593 7.11283 5.47498 3.41958 9.98241 3.3885C11.925 3.37499 13.8169 4.04931 15.3094 5.28783C15.8716 5.75404 16.2135 6.44323 16.2473 7.17837C16.2493 7.21958 16.25 7.2608 16.25 7.30134C16.25 7.30742 16.2493 7.31283 16.2493 7.31891C16.3628 7.23242 16.4736 7.14121 16.5763 7.03783C17.125 6.48986 17.4527 5.7608 17.5101 4.99458C17.5094 5.00404 17.5074 5.01283 17.5067 5.02161C17.5088 4.99864 17.5101 4.97634 17.5121 4.95337C17.5162 4.88715 17.5223 4.82094 17.5223 4.75472V4.75404C17.5223 4.70472 17.5209 4.65472 17.5189 4.6054C17.5189 4.60404 17.5189 4.60337 17.5189 4.60202C17.5142 4.49661 17.5034 4.39188 17.4878 4.28783C17.4811 4.24053 17.4696 4.19526 17.4608 4.14864C17.45 4.09256 17.4405 4.03648 17.4263 3.98175C17.4108 3.92026 17.3912 3.86012 17.3716 3.79931C17.3601 3.76215 17.3493 3.72431 17.3365 3.68783C17.3115 3.61756 17.2824 3.54864 17.252 3.47972C17.2419 3.45607 17.2317 3.43175 17.2209 3.4081C17.1851 3.33175 17.1459 3.25742 17.104 3.18445C17.0966 3.17094 17.0892 3.15675 17.0811 3.14323C17.0344 3.06485 16.9844 2.98783 16.9311 2.9135C16.9263 2.90742 16.9223 2.90067 16.9175 2.89458C16.8608 2.81621 16.8 2.74053 16.7358 2.66688C16.7344 2.66485 16.7324 2.6635 16.7311 2.66148C16.6648 2.58648 16.5946 2.51418 16.5209 2.44458C16.4757 2.40269 16.4324 2.35877 16.3851 2.31891C14.5811 0.821612 12.2946 0.00607042 9.94593 0.0229623C4.4966 0.0621515 0.0499815 4.52567 0.0317383 9.97431Z",
    fill: "url(#paint5_linear_719_3077)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7749 7.93781C14.7351 7.94388 14.6959 7.95064 14.656 7.95469C14.6959 7.95064 14.7351 7.94388 14.7749 7.93781Z",
    fill: "url(#paint6_linear_719_3077)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0649 7.88104C15.0176 7.89253 14.9696 7.90334 14.9216 7.9128C14.9696 7.90402 15.0169 7.89253 15.0649 7.88104Z",
    fill: "url(#paint7_linear_719_3077)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.656 7.95471C14.5661 7.96485 14.4763 7.97228 14.3857 7.97499C14.4763 7.97228 14.5661 7.96485 14.656 7.95471Z",
    fill: "url(#paint8_linear_719_3077)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9216 7.91351C14.873 7.92297 14.8243 7.93041 14.775 7.93784C14.8237 7.93041 14.873 7.92297 14.9216 7.91351Z",
    fill: "url(#paint9_linear_719_3077)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78642 13.8784C2.65669 13.3777 2.5871 12.8567 2.5871 12.3263C2.5871 12.3101 2.5871 12.2939 2.5871 12.277C2.61345 8.94594 5.34453 6.20134 8.67493 6.15878C10.0357 6.14121 11.331 6.55878 12.4202 7.36621C13.5574 8.20878 15.1324 8.16756 16.2479 7.31959C16.2479 7.31351 16.2486 7.30742 16.2486 7.30134C16.2486 7.2608 16.2479 7.21959 16.2459 7.17837C16.2114 6.44324 15.8695 5.75405 15.308 5.28783C13.8155 4.04932 11.9236 3.37499 9.98101 3.3885C5.47358 3.42026 1.79453 7.11283 1.77966 11.6203C1.77966 11.6297 1.77966 11.6392 1.77966 11.6486C1.77966 12.8284 2.02831 13.9669 2.4898 15.0047C2.51953 14.6128 2.62156 14.2317 2.78642 13.8784Z",
    fill: "url(#paint10_linear_719_3077)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5182 4.60605C17.5202 4.65538 17.5216 4.70538 17.5216 4.7547C17.5216 4.84457 17.5142 4.93376 17.506 5.02295C17.5067 5.01349 17.5087 5.0047 17.5094 4.99592C17.9716 6.03376 18.2196 7.17227 18.2196 8.352C18.2196 8.36146 18.2196 8.37092 18.2196 8.38038C18.2047 12.8878 14.5256 16.5811 10.0182 16.6121C8.07564 16.6257 6.18374 15.9513 4.69118 14.7128C4.12901 14.2466 3.78712 13.5574 3.75334 12.8223C3.75131 12.7811 3.75064 12.7398 3.75064 12.6993C3.75064 12.6932 3.75131 12.6871 3.75131 12.6811C4.29726 12.2662 4.95334 12.0459 5.61347 12.0263C4.81415 12.0486 4.02226 12.3642 3.42361 12.9628C2.8182 13.5682 2.47766 14.3932 2.47766 15.2466C2.47766 15.2959 2.47901 15.3459 2.48104 15.3952C2.52226 16.2838 2.93577 17.1169 3.61482 17.6804C5.41888 19.1777 7.70537 19.9932 10.054 19.9763C15.502 19.9385 19.9493 15.475 19.9675 10.0263C19.9675 10.0148 19.9675 10.0034 19.9675 9.99187C19.9675 7.05808 18.7013 4.33038 16.5189 2.44659C17.1162 3.00403 17.4797 3.7797 17.5182 4.60605Z",
    fill: "url(#paint11_linear_719_3077)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2135 6.12159C17.3432 6.62227 17.4128 7.14321 17.4128 7.67362C17.4128 7.68983 17.4128 7.70605 17.4128 7.72294C17.3865 11.054 14.6554 13.7986 11.325 13.8412C9.96418 13.8588 8.66891 13.4412 7.57972 12.6338C6.44256 11.7912 4.86756 11.8324 3.75202 12.6804C3.75202 12.6865 3.75134 12.6925 3.75134 12.6986C3.75134 12.7392 3.75202 12.7804 3.75405 12.8216C3.78851 13.5567 4.1304 14.2459 4.69188 14.7121C6.18445 15.9506 8.07635 16.625 10.0189 16.6115C14.5263 16.5797 18.2054 12.8871 18.2203 8.3797C18.2203 8.37024 18.2203 8.36078 18.2203 8.35132C18.2203 7.17159 17.9716 6.03308 17.5101 4.99524C17.4804 5.38713 17.3784 5.76821 17.2135 6.12159Z",
    fill: "url(#paint12_linear_719_3077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_3077",
    x1: 15.3408,
    y1: 7.80893,
    x2: 15.4114,
    y2: 7.76816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_3077",
    x1: 15.187,
    y1: 7.86776,
    x2: 15.3278,
    y2: 7.78647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_3077",
    x1: 15.4268,
    y1: 7.79505,
    x2: 16.2342,
    y2: 7.32892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_3077",
    x1: 16.2342,
    y1: 7.32884,
    x2: 16.2491,
    y2: 7.32022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_3077",
    x1: 15.0722,
    y1: 7.89455,
    x2: 15.1699,
    y2: 7.83817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_719_3077",
    x1: -0.343018,
    y1: 12.0385,
    x2: 16.5753,
    y2: 2.27066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7673,
    stopColor: "#9EF8CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_719_3077",
    x1: 14.6673,
    y1: 7.97409,
    x2: 14.7637,
    y2: 7.9184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_719_3077",
    x1: 14.9324,
    y1: 7.9322,
    x2: 15.0536,
    y2: 7.86221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_719_3077",
    x1: 14.4156,
    y1: 8.02582,
    x2: 14.6267,
    y2: 7.90393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_719_3077",
    x1: 14.7879,
    y1: 7.96025,
    x2: 14.9084,
    y2: 7.8907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_719_3077",
    x1: 1.78003,
    y1: 9.19645,
    x2: 16.2494,
    y2: 9.19645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EF8CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_719_3077",
    x1: 18.5784,
    y1: 15.0579,
    x2: 6.20989,
    y2: 7.91701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7673,
    stopColor: "#F4BA4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_719_3077",
    x1: 16.7128,
    y1: 13.1614,
    x2: 6.78328,
    y2: 7.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BA4D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDual);
export default __webpack_public_path__ + "static/media/dual.49a5f16008bac46a17a7a46a025beb5b.svg";
export { ForwardRef as ReactComponent };